export default __webpack_public_path__ + "static/network@2x-50219395f166fcc37ed566243c178cc2.png";